import { start } from 'repl'

import FullCalendar from '@fullcalendar/react'
import resourceTimelinePlugin from '@fullcalendar/resource-timeline'

import { useEffect, useMemo, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

import type { FullCalendarApi } from '@/compoments/features/Calendar'
import { CalendarTitleBlock } from '@/compoments/features/CalendarTitleBlock'

import type { IOrderWork } from '@/types/tenant/workGroup.types'
import { enumStatysClasses } from '@/types/tenant/workGroup.types'
import {
    getMediaUrl,
    getStartAndEndOfDay,
    getStartAndEndOfWeek,
} from '@/utils/helpers'

interface WorkingScheduleProps {
    events?: IOrderWork[]
}

export const WorkingSchedule = ({ events }: WorkingScheduleProps) => {
    const [searchParams, setSearchParams] = useSearchParams()
    const params = useMemo(
        () => ({
            view: searchParams.get('view') || 'resourceTimelineDay',
            startDate: searchParams.get('startDate'),
            endDate: searchParams.get('endDate'),
        }),
        [searchParams],
    )
    const [calendarApi, setCalendarApi] = useState<FullCalendarApi>()

    useEffect(() => {
        if (params.startDate && params.endDate) return
        setParams(new Date())
    }, [])

    const setParams = (date: Date) => {
        const { startDate, endDate } = getStartAndEndOfDay(date)
        const { startDate: startDateWeek, endDate: endDateWeek } =
            getStartAndEndOfWeek(date)
        setSearchParams((prev) => {
            const view = prev.get('view')
            prev.set(
                'startDate',
                view === 'resourceTimelineWeek' ? startDateWeek : startDate,
            )
            prev.set(
                'endDate',
                view === 'resourceTimelineWeek' ? endDateWeek : endDate,
            )
            return prev
        })
    }

    useEffect(() => {
        const style = document.createElement('style')
        style.innerHTML = `
            .fc-timeline-body table td {
                width: 50px;
            }
            .fc-timeline-slot-frame {
                width: 100%;
            }
            .fc-timeline-slot.fc-timeline-slot-label.fc-slot.fc-slot-fri.fc-slot-today.fc-slot-past {
                width: 100px;
            }
            .fc-timeline-slot-cushion.fc-scrollgrid-sync-inner {
                text-transform: uppercase;
            }
        `
        document.head.appendChild(style)
        return () => {
            document.head.removeChild(style)
        }
    }, [])

    const handleDateChange = (dateInfo: any) => {
        const { startStr, endStr } = dateInfo
        // setSearchParams((prev) => {
        //     prev.set('startDate', startStr)
        //     prev.set('endDate', endStr)
        //     return prev
        // })
        setParams(startStr)
    }

    const eventsNormalize = useMemo(
        () =>
            events?.map((item) => {
                return {
                    start: item.startTime,
                    end: item.endTime,
                    id: item.id,
                    resourceId: item.id,
                    extendedProps: {
                        status: enumStatysClasses[item.status],
                        title: item.service.name,
                        desk: item.service.category.name,
                    },
                }
            }),
        [events],
    )

    const setView = (view: string) => {
        setSearchParams((prev) => {
            prev.set('view', view)
            return prev
        })
    }
    // if(!params.startDate || !params.endDate) return null
    return (
        <div className="tab flex-auto active-tab" data-id="working-schedule">
            <div className="full-calendar calendar calendar-working-schedule flex-auto">
                <CalendarTitleBlock
                    calendarApi={calendarApi}
                    selectedDate={new Date(params.startDate || new Date())}
                    setView={setView}
                    view={params.view}
                />

                <div className="calendar-body flex-auto">
                    <FullCalendar
                        plugins={[resourceTimelinePlugin]}
                        handleWindowResize={false}
                        initialView={params.view}
                        initialDate={new Date(params.startDate || new Date())}
                        resourceAreaWidth={0}
                        resources={[]}
                        firstDay={1}
                        events={eventsNormalize as []}
                        // resourceLabelContent={({ resource }) => {
                        //     const { status, name, desc } =
                        //         resource.extendedProps
                        //     return {
                        //         html: `<div class="event-calendar-resource event-calendar-resource--head ${status}">
                        //         <div class="event-calendar-status"></div>
                        //         <div class="event-calendar-content">
                        //             <p class="event-calendar-title">${name}</p>
                        //             <p class="event-calendar-desk">${desc}</p>
                        //         </div>
                        //     </div>`,
                        //     }
                        // }}
                        eventContent={({ event }) => {
                            const { user, title, desk, status } =
                                event.extendedProps
                            return {
                                html: `
                                <div class="event-calendar-resource ${status} event-calendar-resource-2">
                                    <div class="ico-avatar btn--square user-calendar-ava">
                                        <img src="${getMediaUrl(user)}" style="width:18px;height:18px" alt="user-photo"/>
                                    </div>
                                    <div class="event-calendar-content">
                                        <p class="event-calendar-title">${title}</p>
                                        <p class="event-calendar-desk">${desk}</p>
                                    </div>
                                </div>
                    `,
                            }
                        }}
                        schedulerLicenseKey="CC-Attribution-NonCommercial-NoDerivatives"
                        ref={(calendarRef) =>
                            setCalendarApi(
                                calendarRef?.getApi() as FullCalendarApi,
                            )
                        }
                        resourceAreaHeaderContent={''}
                        // slotMinTime="08:00:00"
                        // slotMaxTime="23:00:00"
                        views={{
                            resourceTimelineDay: {
                                slotLabelFormat: {
                                    hour: 'numeric',
                                    minute: '2-digit',
                                    meridiem: 'short',
                                },
                            },
                            resourceTimelineWeek: {
                                slotLabelFormat: [
                                    {
                                        weekday: 'long', // Полное название дня недели
                                    },
                                    {
                                        hour: 'numeric',
                                        minute: '2-digit',
                                        meridiem: 'short',
                                    },
                                ],
                            },
                            day: { slotMinWidth: 50 },
                            week: { slotMinWidth: 100 },
                        }}
                        height={'100%'}
                        headerToolbar={false}
                        datesSet={handleDateChange}
                    />
                </div>
            </div>
        </div>
    )
}
